const deps = [
  require('angular-ui-router'),
  require('ui/web/form').name,
  require('ui/bk/clientDetails').name,
];

module.exports = angular
  .module('bench.app.mainapp.details.card', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.details.card', {
      url: '/card',
      resolve: {
        _client(Client, _User) {
          const client = new Client(_User.getClientId());
          return client.$promise.then(() => client);
        },
      },
      views: {
        '': {
          controller($stateParams) {
            this.clientId = $stateParams.clientId;
            return this;
          },
          controllerAs: 'vm',
          template: `\
            <bl-client-details 
              client-id="{{vm.clientId}}"
            />\
          `,
        },
      },
    }),
  );
